/**
 * Retourne le status code
 * @param {object} param0
 * @param {object} param0.error
 * @returns {number}
 */
export default function getErrorStatus({ error }) {
  return error?.status ?? 500;
}
